<script>
import _ from "lodash";
import moment_tz from "moment-timezone";

export default {
  name: "BoardFields",
  methods: {
    vehicleTypeField(value) {
      if (!value) return "";

      return `<p class='normalField'>${
        value === "wp" ? "와인포인트" : "이마트24"
      }</p>`;
    },

    ellipsisStringField(value) {
      if (value == null) return "<span></span>";

      let limit = 20;
      if (value.length > limit) value = value.substring(0, limit) + "…";
      return `<p class='normalField'>${value}</p>`;
    },

    subStringField(value) {
      const isEmpty = _.isEmpty(value);

      if (isEmpty) return "";

      return `<p class='normalField'>${value}</p>`;
    },

    splitBlankField(value) {
      if (value == null) return "";
      let arrValue = value.split(" ");
      value = arrValue.join("<br>");
      return `<p class='normalField'>${value}</p>`;
    },

    winesInCurationField(value) {
      if (Array.isArray(value) && value.length > 0) {
        let wine = value[0];
        return `<p class='normalField'>${wine.short_wine_name}</p><p>${wine.curation_dsc}</p>`;
      }
      return "";
    },

    dateTimeField(value) {
      if (value != null) {
        let value_tz = moment_tz(value).tz("Asia/Seoul");
        let arr = value_tz.format().split("T");
        if (arr.length >= 2) {
          // return `<p class='normalField'>${arr[0]}</p><p>${arr[1]}</p>`;
          return `<p class='normalField'>${arr[0]}</p><p>${arr[1]}</p>`;
        }
      }
      return `<p class='normalField'>${value}</p>`;
    },

    textField(value) {
      const isEmpty = _.isEmpty(value);

      if (isEmpty) return "";

      return value.length > 30
        ? `<p class='normalField'>${value.substring(0, 30)}...</p>`
        : `<p class='normalField'>${value}</p>`;
    },

    numberCommaField(value) {
      if (value == null) return "";

      value = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      return `<p class='normalField'>${value}</p>`;
    },

    imgField(value) {
      return _.isEmpty(value)
        ? "<span></span>"
        : '<span class="imgField ui teal label"><i class="large"></i>IMAGE</span>';
    },

    imageField(value) {
      if (value != null) {
        return `<a href="${value} "><img src="${value}" height="100px"/></a>`;
      }
      return "<span></span>";
    },

    wineColorField(value) {
      if (value == "레드") {
        return `<span class="wine_red">${value}</span>`;
      } else if (value == "로제") {
        return `<span class="wine_rose">${value}</span>`;
      } else {
        return `<span class="wine_white">${value}</span>`;
      }
    },

    // reverseToggleField(value) {
    //   return value === false
    //     ? '<span class="toggle_true">TRUE</span>'
    //     : '<span class="toggle_false">FALSE</span>';
    // },
    // toggleField(value) {
    //   return value
    //     ? '<span class="toggle_true">TRUE</span>'
    //     : '<span class="toggle_false">FALSE</span>';
    // },
    reverseToggleField(value) {
      return value === false
        ? '<span class="checkmark">⬤</span>'
        : '<span class=""></span>';
    },
    toggleField(value) {
      return value
        ? '<span class="checkmark">⬤</span>'
        : '<span class=""></span>';
    },

    boolFieldShowIfTrue(value) {
      return value
        ? '<div style="width:100%;text-align:center;">⬤</div>'
        : "<span></span>";
      //return value ? "⬤" : "<span></span>";
    },

    objectField(value, trackId = "id") {
      const result = [];

      if (value === null) {
        return "";
      }

      value.forEach(data => {
        result.push(data[trackId]);
      });

      return result;
    },

    storeField(value) {
      if (_.isEmpty(value)) return "";
      if (value === "()") return "";

      return value;
    },

    nameField(value) {
      if (!value) return "";

      return value;

      // if (value.legnth < 3) return `${value.substring(0, 1)}*`;

      // let result = value.substr(0, 1);

      // for (let i = 0; i < value.substring(1, value.length - 1).length; i += 1) {
      //   result += '*';
      // }

      // result += value.substr(value.length - 1, 1);

      // return result;
    },

    phoneField(value) {
      if (!value) return "";
      return value;
      // return `010-****-${value.substr(value.length - 4, 4)}`;
    },

    emailField(value) {
      if (!value) return "";

      return value;
      // let result = value.substr(0, 4);

      // for (let i = 0; i < value.substring(4).length; i += 1) {
      //   if (value[i + 4] === '@') result += '@';
      //   else result += '*';
      // }

      // return result;
    }
  }
};
</script>

<style lang='scss'>
.normalField {
  white-space: nowrap;
  line-height: 1;
}

.right-space {
  margin-right: 5px;
}

.imgField {
  cursor: pointer;
  background-color: rgb(255, 120, 50) !important;
}

.toggle_true {
  padding: 5px 10px 5px 10px;
  background-color: rgb(0, 181, 173);
  border-radius: 5px;
  color: rgb(255, 255, 255);
  font-size: 0.85714286rem;
  font-weight: 700;
}

.checkmark {
  padding: 5px 10px 5px 10px;
  color: rgb(0, 0, 255);
  font-size: 0.85714286rem;
  font-weight: 700;
}

.toggle_false {
  padding: 5px 10px 5px 10px;
  background-color: rgb(255, 120, 50);
  border-radius: 5px;
  color: rgb(255, 255, 255);
  font-size: 0.85714286rem;
  font-weight: 700;
}

.wine_red {
  padding: 5px 10px 5px 10px;
  background-color: #722f37;
  border-radius: 5px;
  color: rgb(255, 255, 255);
  font-size: 0.85714286rem;
  font-weight: 700;
}

.wine_white {
  padding: 5px 10px 5px 10px;
  background-color: #f1f285;
  border-radius: 5px;
  color: black;
  font-size: 0.85714286rem;
  font-weight: 700;
}

.wine_rose {
  padding: 5px 10px 5px 10px;
  background-color: #9f5057;
  border-radius: 5px;
  color: white;
  font-size: 0.85714286rem;
  font-weight: 700;
}

.row-submit {
  background-color: rgba(104, 180, 205, 0.1);
}

.row-none {
  background-color: rgb(255, 255, 255);
}

.pagination-wrapper {
  height: 40px;
}

.pagination-info-wrapper {
  font-size: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/mixins/BoardFields.vue